import { useState } from 'react';
import { Modal } from '../../../components';
import Contact from './Contact';

const PropertyDesc = ({
  overview,
  details,
  unitType,
  unitIndex,
  changeUnit,
  pdf,
}) => {
  const [showFloorPlan, setShowFloorPlan] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [floorPlanSrc, setFloorPlanSrc] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const tabs = ['Overview', 'Details', 'FloorPlans'];
  const txt = unitType[unitIndex].floor_plans.txt;
  const photosBigURL = unitType[unitIndex].floor_plans.photosBigURL;
  const photosURL = unitType[unitIndex].floor_plans.photosURL;

  return (
    <div className="property__desc">
      {showFloorPlan && (
        <Modal toggleShow={() => setShowFloorPlan(false)}>
          <img src={floorPlanSrc} alt="bigPic" />
        </Modal>
      )}
      {showContactModal && (
        <Modal toggleShow={() => setShowContactModal(false)} isContact={true}>
          <Contact txt="To learn more please contact one of our advisors." />
        </Modal>
      )}
      <div className="property__desc--info">
        <div className="tabs">
          {tabs.map((tab, i) => (
            <h3
              key={tab}
              className={`tab ${tabIndex === i ? 'active' : ''}`}
              onClick={() => setTabIndex(i)}
            >
              {tab}
            </h3>
          ))}
        </div>

        <div>
          {tabIndex === 0 && <p>{overview}</p>}
          {tabIndex === 1 && (
            <ul>
              {details.map((detail, i) => (
                <li key={i}>{detail}</li>
              ))}
            </ul>
          )}
          {tabIndex === 2 && (
            <>
              <ul>
                {txt.length > 0 && txt.map((t, i) => <li key={i}>{t}</li>)}
              </ul>
              {photosURL.length > 0 && photosURL[0] !== '' ? (
                photosURL.map((url, i) => (
                  <img
                    key={i}
                    src={url}
                    alt="plans"
                    loading="lazy"
                    onClick={() => {
                      setShowFloorPlan(true);
                      setFloorPlanSrc(photosBigURL[i]);
                    }}
                  />
                ))
              ) : (
                <p>No floor plans available</p>
              )}
            </>
          )}
        </div>

        <div className="btns-container">
          {pdf ? (
            <a
              className="btn-b big"
              href={pdf}
              target="_blank"
              rel="noreferrer"
            >
              Property Catalog
            </a>
          ) : (
            <button
              className="btn-b big"
              onClick={() => setShowContactModal(true)}
            >
              Property Catalog
            </button>
          )}
          <button
            className="btn-b active big"
            onClick={() => setShowContactModal(true)}
          >
            Contact Agent
          </button>
        </div>
      </div>

      <div className="property__desc--unit">
        <h3 className="tab active center">Unit Type</h3>

        <div className="units">
          {unitType.map((unit, i) => (
            <button
              key={unit.id}
              className={`btn-b ${i === unitIndex ? 'active' : ''}`}
              onClick={() => changeUnit(i)}
            >
              {unit.txt}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PropertyDesc;
